import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e38fb74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-switch-container" }
const _hoisted_2 = {
  key: 0,
  class: "address-ai-credits-container"
}
const _hoisted_3 = { class: "ai-info-text" }
const _hoisted_4 = { class: "ai-info-text-value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-basket-shopping-plus" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "progress-bar-container" }
const _hoisted_8 = { class: "pictures-page property-listing-page" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "picture-upload-warning" }, " To ensure the AI generated content is as accurate as possible, photos must be uploaded ideally with a floorplan. ", -1))
const _hoisted_10 = { class: "floor-page property-listing-page" }
const _hoisted_11 = { class: "features-page property-listing-page" }
const _hoisted_12 = { class: "generated-descriptions property-listing-page" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ai-warning-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ai-warning" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "disclaimer-title" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "far fa-triangle-exclamation" }),
      /*#__PURE__*/_createTextVNode("AI Disclaimer:")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" AI-generated content is provided for assistance. It is your responsibility to review for final accuracy. ")
  ])
], -1))
const _hoisted_14 = { class: "rooms-page property-listing-page" }
const _hoisted_15 = { class: "button-container" }
const _hoisted_16 = { class: "rooms-grid-container" }
const _hoisted_17 = { class: "tenant-switch-footer-container" }
const _hoisted_18 = { class: "steps" }

import { computed, inject, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import TenantSwitchProgress from "@/components/switches/tenant-switch-progress.vue";
import DxMultiView from "devextreme-vue/multi-view";
import { QuestionsWizardData } from "@/types/wizard/question-wizard-data";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import NumberBoxField from "@/components/ui/inputs/number-box-field.vue";
import { Properties } from "acquaint-api/models/Properties";
import { PropertyListingResponse } from "@/types/properties/ai/PropertyListingResponse";
import { DxButton } from "devextreme-vue";
import FieldValidationFreeTextArea from "@/components/ui/inputs/field-validation-free-text-area.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { FieldSize } from "@/enums/system/FieldSize";
import { loadingSpinnerAlert } from "@/alerts/loadingSpinnerAlert";
import { baseAlert } from "@/alerts/baseAlert";
import { PropertyRooms } from "acquaint-api/models/PropertyRooms";
import { formatAddress } from "@/utils/address/AddressFormatter";
import PropertyListingFloorUpload from "@/components/properties/record/property-listing-floor-upload.vue";
import PropertyListingPictureManagement from "@/components/carousel-pictures/property-listing-picture-management.vue";
import { AIPropertyListingWizardSteps } from "@/enums/ai/AIPropertyListingWizardSteps";
import { WizardStepStatus } from "@/enums/WizardSteps";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { PropertyListingRoomResponse } from "@/types/properties/ai/PropertyListingRoomResponse";
import EditPropertyListingRoom from "@/components/properties/edit-property-listing-room.vue";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import GridMenu from "@/components/ui/grid/grid-menu.vue";
import ScrollView from "@/components/ui/scroll-view.vue";
import FieldValidationFreeTextbox from "@/components/ui/inputs/field-validation-free-textbox.vue";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-property-listing-wizard',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The ID of the property for which for AI descriptions will be generated.
   */
  propertyId: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `showModal` state changes.
   * This is used to update the modal visibility in the parent component.
   * @property {boolean} value - The new state for showing or hiding the modal.
   */
  "update:modelValue",
  /**
   * Triggered when the modal is closed.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const displayCancelConfirmationModal = ref(true);
const keepingModalOpening = ref(false);
const saving = ref(false);
const selectedIndex = ref(AIPropertyListingWizardSteps.Pictures);
const stageTwo = ref(WizardStepStatus.InComplete);
const stageThree = ref(WizardStepStatus.InComplete);
const stageFour = ref(WizardStepStatus.InComplete);
const stageFive = ref(WizardStepStatus.InComplete);
const pageNumber = computed(() => selectedIndex.value + 1);
const aiResponse = ref<PropertyListingResponse>({
  briefDescription: "",
  fullDescription: "",
  bulletPoints: [],
  rooms: [],
});
const dataEditedAfterGeneration = ref(false);
const picturesUpdatedSinceInitialGeneration = ref(false);
const gridKey = ref(0);
const pictureCount = ref(0);
const propertyData = ref<Properties>();
const originalData = ref<Properties>();
const dataBeforeGeneration = ref<Properties>();
const displayInitialPicturePlanData = ref(0);
const recordLocked = ref(false);
const aiCredits = ref(0);
const selectedRoom = ref<PropertyListingRoomResponse>();
const displayEditRoomModal = ref(false);
const alreadyGeneratedOnce = ref(false);
const disableNextButton = computed(() => {
  if (selectedIndex.value == AIPropertyListingWizardSteps.Pictures) {
    return pictureCount.value == 0 || invalidImagesAdded.value;
  }
  return false;
});
const invalidImagesAdded = ref(false);
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();

// Each page must be assigned a template name for it to appear
const pages = ref<QuestionsWizardData[]>([
  {
    template: "pictures",
  },
  {
    template: "floorPlans",
  },
  {
    template: "features",
  },
  {
    template: "generatedDescriptions",
  },
  {
    template: "generatedRooms",
  },
]);
const nextSubmitButtonText = computed(() => {
  switch (selectedIndex.value) {
    case AIPropertyListingWizardSteps.GeneratedRooms:
      return "Save";
    case AIPropertyListingWizardSteps.Features:
      // After generating once, the button text will be set to Next unless the data has been edited since generation.
      // This will users to re-generate the content if they have made changes.
      if (!alreadyGeneratedOnce.value || dataEditedAfterGeneration.value) {
        return "Generate";
      }
      return "Next";
    case AIPropertyListingWizardSteps.Pictures:
      return "Floor Plan";
    default:
      return "Next";
  }
});

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }
    displayCancelConfirmationModal.value = true;
    selectedIndex.value = AIPropertyListingWizardSteps.Pictures;
    await lockProperty(true);
    if (recordLocked.value) {
      displayCancelConfirmationModal.value = false;
      setTimeout(() => {
        baseAlert.close();
        showModal.value = false;
      }, 5000);
      return;
    }
    await fetchProperty();
    fetchAICredits();
    propertyData.value = originalData.value
      ? JSON.parse(JSON.stringify(originalData.value))
      : undefined;

    const pictureArray = propertyData.value?.pictures
      ? propertyData.value.pictures.split("|")
      : [];
    pictureCount.value = pictureArray.length ?? 0;
    displayInitialPicturePlanData.value++;
    alreadyGeneratedOnce.value = false;
    dataEditedAfterGeneration.value = false;
    picturesUpdatedSinceInitialGeneration.value = false;
    currentUser.value = await currentUserStore.getCurrentUserDetails();
  },
);

watch(
  () => selectedIndex.value,
  () => {
    switch (selectedIndex.value) {
      case AIPropertyListingWizardSteps.Pictures: {
        stageTwo.value = WizardStepStatus.InComplete;
        stageThree.value = WizardStepStatus.InComplete;
        stageFour.value = WizardStepStatus.InComplete;
        stageFive.value = WizardStepStatus.InComplete;
        break;
      }
      case AIPropertyListingWizardSteps.FloorPlans: {
        stageTwo.value = WizardStepStatus.Complete;
        stageThree.value = WizardStepStatus.InComplete;
        stageFour.value = WizardStepStatus.InComplete;
        stageFive.value = WizardStepStatus.InComplete;
        break;
      }
      case AIPropertyListingWizardSteps.Features: {
        stageTwo.value = WizardStepStatus.Complete;
        stageThree.value = WizardStepStatus.Complete;
        stageFour.value = WizardStepStatus.InComplete;
        stageFive.value = WizardStepStatus.InComplete;
        break;
      }
      case AIPropertyListingWizardSteps.GeneratedDescription: {
        stageTwo.value = WizardStepStatus.Complete;
        stageThree.value = WizardStepStatus.Complete;
        stageFour.value = WizardStepStatus.Complete;
        stageFive.value = WizardStepStatus.InComplete;
        break;
      }
      case AIPropertyListingWizardSteps.GeneratedRooms: {
        stageTwo.value = WizardStepStatus.Complete;
        stageThree.value = WizardStepStatus.Complete;
        stageFour.value = WizardStepStatus.Complete;
        stageFive.value = WizardStepStatus.Complete;
        break;
      }
    }
  },
);

watch(
  [() => propertyData.value, () => picturesUpdatedSinceInitialGeneration.value],
  () => {
    // Before first generation, always show "Generate"
    if (!alreadyGeneratedOnce.value) {
      dataEditedAfterGeneration.value = false;
      return;
    }
    // This is set to true if the ai response has not yet been generated once or if the data has been edited since the last generation.
    // This is used to change the next button text from Next to Generate on the features page.
    // If the response has been generated but the data has not been edited, the button text is Next.
    const hasSameFloorPlan =
      propertyData.value?.floorPlanFileNameWeb ==
      dataBeforeGeneration.value?.floorPlanFileNameWeb;
    const hasSameBathrooms =
      propertyData.value?.bathrooms == dataBeforeGeneration.value?.bathrooms;
    const hasSameBedrooms =
      propertyData.value?.bedrooms == dataBeforeGeneration.value?.bedrooms;
    const hasSameReceptionRooms =
      propertyData.value?.receptionRooms ==
      dataBeforeGeneration.value?.receptionRooms;

    const nothingChanged =
      !picturesUpdatedSinceInitialGeneration.value &&
      hasSameFloorPlan &&
      hasSameBathrooms &&
      hasSameBedrooms &&
      hasSameReceptionRooms;

    dataEditedAfterGeneration.value = !nothingChanged;
  },
  { deep: true },
);

const lockProperty = async (lock: boolean) => {
  try {
    await acquaintApiClient.httpPostVoid(
      `database/properties/${props.propertyId}/lock`,
      {
        lock: lock,
        extraInfo: "",
      },
    );
    recordLocked.value = false;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    recordLocked.value = true;
  }
};

const fetchAICredits = async () => {
  try {
    aiCredits.value = await apiNextClient.httpGet(
      "AIResponse/GetAICreditBalance",
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    aiCredits.value = 0;
  }
};

const onAICreditsClick = async () => {
  const sitePrefix = await currentUserStore.getSitePrefix();
  const siteId = currentUser.value?.siteID ?? 0;

  const url = `https://www.acquaintcrm.co.uk/PurchaseAICredits.aspx?SitePrefix=${sitePrefix}&SiteID=${siteId}`;

  window.open(url, "_blank");
};

const fetchProperty = async () => {
  try {
    originalData.value = await acquaintApiClient.httpGet(
      `database/properties/${props.propertyId}`,
    );
  } catch (err) {
    await displayErrorMessage(getErrorMessage(err));
    originalData.value = undefined;
  }
};

// Logic for submitting data and generating the AI descriptions
const onGenerateClick = async () => {
  await alignImageFloorPlanData();
  if (!(await submitData())) {
    return false;
  }

  return await generateAIContent();
};

// Within the floorplan and pictures commponents, the user may have made changes to the pictures and floor plans in the database.
// If we don't align these back to the property data here, those changes will be lost when we submit the data.
// When the data is first loaded, these fields are blank so submitting blank fields would remove any new pictures or floor plans.
const alignImageFloorPlanData = async () => {
  await fetchProperty();
  if (!originalData.value || !propertyData.value) {
    return;
  }
  propertyData.value.pictures = originalData.value.pictures;
  propertyData.value.floorPlanFileNamePrint =
    originalData.value.floorPlanFileNamePrint;
  propertyData.value.floorPlanFileNameWeb =
    originalData.value.floorPlanFileNameWeb;
};

const submitData = async () => {
  try {
    await acquaintApiClient.httpPut(
      `database/properties/${props.propertyId}`,
      propertyData.value,
    );
    return true;
  } catch (err) {
    await displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const generateAIContent = async () => {
  try {
    aiResponse.value = await apiNextClient.httpGet(
      `PropertyListing/${props.propertyId}`,
    );
    return true;
  } catch (err) {
    await displayErrorMessage(
      getErrorMessage("The AI content could not be generated."),
    );
    aiResponse.value = {
      briefDescription: "",
      fullDescription: "",
      bulletPoints: [],
      rooms: [],
    };
    return false;
  }
};

const onSaveClick = async () => {
  saving.value = true;
  if (!propertyData.value) {
    return false;
  }

  if (!(await deleteAllCurrentRooms())) {
    return false;
  }
  await createRooms();
  propertyData.value.bulletPoints = aiResponse.value.bulletPoints.join(" *");
  if (!(await submitData())) {
    return false;
  }
  displayCancelConfirmationModal.value = false;
  showModal.value = false;
  saving.value = false;
  emit("modalClosed");
};

// To avoid duplicates, we must delete all the existing rooms for the property and create new ones based on the AI response.
const deleteAllCurrentRooms = async () => {
  try {
    await apiNextClient.httpDelete(
      `properties/${props.propertyId}/deleterooms`,
      null,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const createRooms = async () => {
  for (let i = 0; i < aiResponse.value.rooms.length; i++) {
    const width = aiResponse.value.rooms[i].width;
    const length = aiResponse.value.rooms[i].length;
    const room: PropertyRooms = {
      propertyID: props.propertyId,
      id: i + 1,
      description: aiResponse.value.rooms[i].name,
      fullDescription: aiResponse.value.rooms[i].description,
      width: aiResponse.value.rooms[i].width ?? 0,
      widthSuffix: 0,
      length: aiResponse.value.rooms[i].length ?? 0,
      lengthSuffix: 0,
      floorArea: width !== null && length !== null ? length * width : 0,
      displayOrder: i + 1,
    };
    await submitRoom(room);
  }
};

const submitRoom = async (room: PropertyRooms) => {
  try {
    await acquaintApiClient.httpPost(`database/propertyrooms`, room);
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

// Logic for navigating between pages
const onNavigateClick = async (direction: number) => {
  if (
    !direction &&
    selectedIndex.value > AIPropertyListingWizardSteps.Pictures
  ) {
    selectedIndex.value--;
    return;
  }

  if (selectedIndex.value < AIPropertyListingWizardSteps.Features) {
    selectedIndex.value++;
    return;
  }

  if (selectedIndex.value == AIPropertyListingWizardSteps.Features) {
    if (alreadyGeneratedOnce.value && !dataEditedAfterGeneration.value) {
      selectedIndex.value++;
      return;
    }

    // If more than 50 pictues have been uploaded, including the floor plan, the user needs to be warned the first 50 images inlcuding the floor plan will be used for the AI generation.
    if (
      pictureCount.value > 50 &&
      propertyData.value?.floorPlanFileNameWeb == ""
    ) {
      await standardInfoAlert(
        "The first 50 images can only be used for AI generation.",
      );
    } else if (
      pictureCount.value > 49 &&
      propertyData.value?.floorPlanFileNameWeb != ""
    ) {
      await standardInfoAlert(
        "The first 49 images plus the floor plan can only be used for AI generation.",
      );
    }

    saving.value = true;
    loadingSpinnerAlert(
      "",
      '<div class="loading-spinner-content">Generating the property listing, this may take a while...</div>',
    );
    if (!(await onGenerateClick()) || !propertyData.value) {
      baseAlert.close();
      saving.value = false;
      return;
    }

    alreadyGeneratedOnce.value = true;
    dataBeforeGeneration.value = JSON.parse(JSON.stringify(propertyData.value));
    propertyData.value.description = aiResponse.value.briefDescription;
    propertyData.value.fullDescription = aiResponse.value.fullDescription;
    propertyData.value.bulletPoints = aiResponse.value.bulletPoints.join(" *");
    setTimeout(async () => {
      gridKey.value++;
      saving.value = false;
      baseAlert.close();
      await fetchAICredits();
      selectedIndex.value++;
    }, 100);
    return;
  }

  if (
    selectedIndex.value == AIPropertyListingWizardSteps.GeneratedDescription
  ) {
    selectedIndex.value++;
    return;
  }

  if (selectedIndex.value == AIPropertyListingWizardSteps.GeneratedRooms) {
    await onSaveClick();
  }
};

const modalClosed = async () => {
  displayInitialPicturePlanData.value++;
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed");
  if (!recordLocked.value) {
    await lockProperty(false);
  }
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

// Update picture count when images are added or removed in the picture management component so that the next button can be enabled/disabled appropriately
const imageListUpdated = async (newPictureCount: number) => {
  pictureCount.value = newPictureCount;
};

const invalidImagesFound = (invalidImageCount: number) => {
  if (invalidImageCount > 0) {
    invalidImagesAdded.value = true;
  } else {
    invalidImagesAdded.value = false;
  }
};

// If the picture count changes after the initial generation, we need to set picturesUpdatedSinceInitialGeneration to true so that the next button text changes to Generate on the features page.
watch(
  () => pictureCount.value,
  () => {
    picturesUpdatedSinceInitialGeneration.value = alreadyGeneratedOnce.value;
  },
);

// Logic for selecting and editing rooms in the grid
const roomDblClick = (e: PropertyListingRoomResponse) => {
  if (!e) return;

  selectedRoom.value = e;
  displayEditRoomModal.value = true;
};

const roomSingleClick = (e: PropertyListingRoomResponse) => {
  if (!e) return;

  selectedRoom.value = e;
};

const roomEdited = (
  saved: boolean,
  updatedRoom?: PropertyListingRoomResponse,
) => {
  if (!saved || !updatedRoom || !aiResponse.value) {
    return;
  }

  const index = aiResponse.value.rooms.findIndex(
    (r) => r.id === updatedRoom.id,
  );
  if (index !== -1) {
    aiResponse.value.rooms[index] = { ...updatedRoom };
  }
  gridKey.value++;
};

const roomsMenu = computed(() => {
  const list: ContextMenuItem[] = [
    {
      key: "editRoom",
      text: "Edit Room",
      icon: "fas fa-pencil",
      disabled: !selectedRoom.value,
    },
    {
      key: "deleteRoom",
      text: "Delete Room",
      icon: "fas fa-trash",
      disabled: !selectedRoom.value,
    },
  ];
  return list;
});

const editRoomsClick = () => {
  displayEditRoomModal.value = true;
};

const deleteRoom = async () => {
  if (!selectedRoom.value || !aiResponse.value) {
    return;
  }

  aiResponse.value.rooms.filter((r) => r.id !== selectedRoom.value?.id);

  selectedRoom.value = undefined;
  gridKey.value++;
};

const roomsMenuItemClicked = (key: string) => {
  switch (key) {
    case "editRoom":
      editRoomsClick();
      break;
    case "deleteRoom":
      deleteRoom();
      break;
  }
};

const nameWidth = computed(() => {
  return screen.width < 768 ? "255px" : "100px";
});

const contentHeight = computed(() => {
  return screen.width >= 768 ? "calc(100% - 140px)" : "calc(100% - 160px)";
});

const floorPlanEditted = (success: boolean, newData: Properties) => {
  if (!success || !propertyData.value) {
    return;
  }
  propertyData.value.floorPlanFileNamePrint = newData.floorPlanFileNamePrint;
  propertyData.value.floorPlanFileNameWeb = newData.floorPlanFileNameWeb;
};

const nextButtonIconPosition = computed(() => {
  return selectedIndex.value === AIPropertyListingWizardSteps.Features
    ? false
    : true;
});

const nextButtonIcon = computed(() => {
  return selectedIndex.value === AIPropertyListingWizardSteps.Features
    ? "fa-solid fa-wand-magic-sparkles"
    : "spinright";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showModal).value = $event)),
      title: "AI Property Listing",
      height: "900px",
      onCancelPromptDenied: cancelPromptDenied,
      onModalClosed: modalClosed,
      showCloseConfirmationPrompt: displayCancelConfirmationModal.value,
      width: _unref(ModalWidth).Large,
      customCloseConfirmationText: "If you close now, you will lose progress on an AI generation you have spent credits on without saving. Are you sure?"
    }, {
      "non-scrollable-content": _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          (propertyData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(_unref(formatAddress)(
              propertyData.value?.propertyName,
              propertyData.value?.street,
              propertyData.value?.locality,
              propertyData.value?.town,
              propertyData.value?.region,
              propertyData.value?.postcode,
              propertyData.value?.country,
            )), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_3, [
                    _createTextVNode("Credits Remaining: "),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(aiCredits.value?.toString() ?? "0"), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "ai-buy-button",
                    title: "Buy Credits",
                    onClick: onAICreditsClick
                  }, _hoisted_6)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_7, [
            _createVNode(TenantSwitchProgress, {
              fontSize: "14px",
              index: selectedIndex.value,
              title: "Pictures",
              number: _unref(AIPropertyListingWizardSteps).Pictures + 1,
              progress: stageTwo.value
            }, null, 8, ["index", "number", "progress"]),
            _createVNode(TenantSwitchProgress, {
              fontSize: "14px",
              index: selectedIndex.value,
              title: "Floor Plans",
              number: _unref(AIPropertyListingWizardSteps).FloorPlans + 1,
              progress: stageThree.value
            }, null, 8, ["index", "number", "progress"]),
            _createVNode(TenantSwitchProgress, {
              fontSize: "14px",
              index: selectedIndex.value,
              title: "Features",
              number: _unref(AIPropertyListingWizardSteps).Features + 1,
              progress: stageFour.value
            }, null, 8, ["index", "number", "progress"]),
            _createVNode(TenantSwitchProgress, {
              fontSize: "14px",
              index: selectedIndex.value,
              title: "AI Descriptions",
              number: _unref(AIPropertyListingWizardSteps).GeneratedDescription + 1,
              progress: stageFive.value
            }, null, 8, ["index", "number", "progress"]),
            _createVNode(TenantSwitchProgress, {
              fontSize: "14px",
              index: selectedIndex.value,
              title: "AI Rooms",
              number: _unref(AIPropertyListingWizardSteps).GeneratedRooms + 1,
              progress: -1
            }, null, 8, ["index", "number"])
          ]),
          (propertyData.value)
            ? (_openBlock(), _createBlock(_unref(DxMultiView), {
                key: 1,
                height: contentHeight.value,
                width: "100%",
                "selected-index": selectedIndex.value,
                "onUpdate:selectedIndex": _cache[5] || (_cache[5] = ($event: any) => ((selectedIndex).value = $event)),
                loop: false,
                "animation-enabled": true,
                "data-source": pages.value,
                "swipe-enabled": false
              }, {
                pictures: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(PropertyListingPictureManagement, {
                      "picture-count": pictureCount.value,
                      "refresh-data": displayInitialPicturePlanData.value,
                      recordId: props.propertyId,
                      onImageListUpdated: imageListUpdated,
                      onInvalidImages: invalidImagesFound
                    }, null, 8, ["picture-count", "refresh-data", "recordId"])
                  ])
                ]),
                floorPlans: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(PropertyListingFloorUpload, {
                      "property-id": __props.propertyId,
                      "fetch-data": displayInitialPicturePlanData.value,
                      permissionToEdit: true,
                      propertyData: propertyData.value,
                      onPlanAdded: floorPlanEditted,
                      onPlanDeleted: floorPlanEditted
                    }, null, 8, ["property-id", "fetch-data", "propertyData"])
                  ])
                ]),
                features: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(NumberBoxField, {
                      label: "Bedrooms",
                      modelValue: propertyData.value.bedrooms,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((propertyData.value.bedrooms) = $event)),
                      width: _unref(FieldSize).Medium
                    }, null, 8, ["modelValue", "width"]),
                    _createVNode(NumberBoxField, {
                      label: "Bathrooms",
                      modelValue: propertyData.value.bathrooms,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((propertyData.value.bathrooms) = $event)),
                      width: _unref(FieldSize).Medium
                    }, null, 8, ["modelValue", "width"]),
                    _createVNode(NumberBoxField, {
                      label: "Reception Rooms",
                      modelValue: propertyData.value.receptionRooms,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((propertyData.value.receptionRooms) = $event)),
                      width: _unref(FieldSize).Medium
                    }, null, 8, ["modelValue", "width"])
                  ])
                ]),
                generatedDescriptions: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(ScrollView, null, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(FieldValidationFreeTextArea, {
                          label: "Brief Description",
                          modelValue: propertyData.value.description,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((propertyData.value.description) = $event)),
                          height: "6rem"
                        }, null, 8, ["modelValue"]),
                        _createVNode(FieldValidationFreeTextArea, {
                          label: "Full Description",
                          modelValue: propertyData.value.fullDescription,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((propertyData.value.fullDescription) = $event)),
                          height: "11rem"
                        }, null, 8, ["modelValue"]),
                        _createTextVNode(" Bullet Points "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiResponse.value.bulletPoints, (bulletPoint, index) => {
                          return (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                            key: index,
                            modelValue: aiResponse.value.bulletPoints[index],
                            "onUpdate:modelValue": ($event: any) => ((aiResponse.value.bulletPoints[index]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                generatedRooms: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createTextVNode(" Rooms "),
                      _createVNode(GridMenu, {
                        "menu-items": roomsMenu.value,
                        onItemClicked: roomsMenuItemClicked,
                        id: "ai-property-listing-rooms-grid-menu",
                        atPosition: "bottom right",
                        myPosition: "top right"
                      }, null, 8, ["menu-items"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(), _createBlock(GridBase, {
                        key: gridKey.value,
                        "show-column-filters": false,
                        "show-search-panel": false,
                        "word-wrap-enabled": true,
                        dataSource: aiResponse.value.rooms,
                        onRowClick: roomDblClick,
                        onRowSelected: roomSingleClick,
                        onAdaptiveRowSelection: roomSingleClick,
                        preSelectedId: selectedRoom.value?.id ?? -1
                      }, {
                        columns: _withCtx(() => [
                          _createVNode(_unref(DxColumn), {
                            "data-field": "id",
                            caption: "Id",
                            visible: false,
                            "hiding-priority": 4
                          }),
                          _createVNode(_unref(DxColumn), {
                            "data-field": "name",
                            caption: "Name",
                            "hiding-priority": 4,
                            width: nameWidth.value
                          }, null, 8, ["width"]),
                          _createVNode(_unref(DxColumn), {
                            "data-field": "description",
                            caption: "Description",
                            "hiding-priority": 3,
                            "min-width": "430px"
                          }),
                          (aiResponse.value.rooms[0].length != null)
                            ? (_openBlock(), _createBlock(_unref(DxColumn), {
                                key: 0,
                                "data-field": "length",
                                caption: "Length",
                                "hiding-priority": 2
                              }))
                            : _createCommentVNode("", true),
                          (aiResponse.value.rooms[0].width != null)
                            ? (_openBlock(), _createBlock(_unref(DxColumn), {
                                key: 1,
                                "data-field": "width",
                                caption: "Width",
                                "hiding-priority": 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["dataSource", "preSelectedId"]))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["height", "selected-index", "data-source"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("section", _hoisted_17, [
          _createElementVNode("div", {
            class: _normalizeClass({
            hideButton: selectedIndex.value == _unref(AIPropertyListingWizardSteps).Pictures,
          })
          }, [
            _createVNode(_unref(DxButton), {
              text: "Back",
              onClick: _cache[6] || (_cache[6] = () => onNavigateClick(0)),
              icon: "spinleft",
              disabled: saving.value
            }, null, 8, ["disabled"])
          ], 2),
          _createElementVNode("span", _hoisted_18, _toDisplayString(pageNumber.value) + " of 5", 1),
          _createVNode(_unref(DxButton), {
            class: _normalizeClass([
            'base-class',
            selectedIndex.value == _unref(AIPropertyListingWizardSteps).Features
              ? 'generate-ai-button'
              : '',
          ]),
            text: nextSubmitButtonText.value,
            onClick: _cache[7] || (_cache[7] = () => onNavigateClick(1)),
            icon: nextButtonIcon.value,
            rtlEnabled: nextButtonIconPosition.value,
            disabled: saving.value || !propertyData.value || disableNextButton.value
          }, null, 8, ["class", "text", "icon", "rtlEnabled", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "showCloseConfirmationPrompt", "width"]),
    (selectedRoom.value)
      ? (_openBlock(), _createBlock(EditPropertyListingRoom, {
          key: 0,
          modelValue: displayEditRoomModal.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((displayEditRoomModal).value = $event)),
          room: selectedRoom.value,
          onModalClosed: roomEdited
        }, null, 8, ["modelValue", "room"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})